import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Box } from 'grommet';
import { useAppTheme } from '@Components/Context';
import { AppButton } from '@Components/Control';
import {
  NoDataPlaceholder,
  TableWrapper,
} from '../SharedComponents';
import { StyledModalSelectButton } from '../NewSearch/StyledProductFormComponent';


const PlatformSelectTable = ({
  small,
  loading,
  options = null,
  selectedOptions = null,
  pageTitle = null,
  updateSelections,
  paymentPending = false,
}) => {
  const [selected, setSelected] = React.useState([]);
  const { theme: { page, button } } = useAppTheme();

  React.useEffect(() => {
    if (selectedOptions) setSelected(selectedOptions);
  }, [selectedOptions]);

  const handleSelection = (uid) => {
    const prevSelected = [...selected];
    if (prevSelected.includes(uid)) {
      _.pull(prevSelected, uid);
    } else {
      prevSelected.push(uid);
    }

    setSelected(prevSelected);
  };

  const renderContents = () => {
    if (loading || !options) {
      return (
        <NoDataPlaceholder
          noShadow
          noRound
          showRefreshButton={false}
          buttonHighlight={button.primaryBg}
          loading={loading}
          label="Error loading settings data"
          textColor={page.primaryText}
          loaderColor={page.highlight}
        />
      );
    }

    return (
      <Box wrap direction="row">
        {options?.length > 0 && options.map((dt) => (
          <Box key={dt} pad={{ right: '1rem', vertical: '0.5rem' }}>
            <StyledModalSelectButton
              plain
              selected={selected?.includes(dt)}
              textSize="1rem"
              onClick={() => handleSelection(dt)}
              primaryText={page.modalText}
              buttonHighlight={button.hoverText}
              buttonBg={button.hoverBg}
              label={dt}
            />
          </Box>
        ))}
      </Box>
    );
  };

  const arraysEqual = (a, b) => (a?.length === b?.length && a.every((v) => b.includes(v)));
  const saveDisabled = arraysEqual(selected, selectedOptions) || paymentPending;

  return (
    <Box direction="column" fill="horizontal">
      <TableWrapper
        small={small}
        header={pageTitle}
        boxPad={{ horizontal: small ? '1.5rem' : '2rem', top: '1rem', bottom: small ? '1.5rem' : '2rem' }}
        tableControls={(
          <Box direction="row" gap="0.5rem">
            <AppButton
              overrideHover
              disabled={saveDisabled}
              onClick={() => updateSelections(selectedOptions, selected)}
              level="tableControls"
              color={button.primaryText}
              bgColor={button.primaryBg}
              fontWeight={600}
              label="Save Changes"
            />
          </Box>
        )}
      >
        <Box>
          {renderContents()}
        </Box>
      </TableWrapper>
    </Box>
  );
};

PlatformSelectTable.propTypes = {
  small: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  selectedOptions: PropTypes.arrayOf(PropTypes.string),
  options: PropTypes.arrayOf(PropTypes.string),
  pageTitle: PropTypes.string,
  updateSelections: PropTypes.func.isRequired,
  paymentPending: PropTypes.bool,
};

export default PlatformSelectTable;
